module.exports = __webpack_public_path__ + "static/media/main-weapon.58472188.png";